import { useMemo }            from 'react';
import styled                 from 'styled-components';
import { SelectAutocomplete } from '@shared/inputs/SelectAutocomplete';
import { IAllUsers, IOption } from '@shared/interfaces';

const defaultValue = {
  label : 'Defaults',
  value : '',
};

const Wrapper = styled.div`
  > div:last-of-type {
    min-width: 200px;
  }
`;

interface IHeaderContentProps {
  currentUser: string | null;
  onChangeUser: (userId: string | null) => void;
  users: IAllUsers['groupUsers'];
}

export const Header = ({ currentUser, onChangeUser, users }: IHeaderContentProps) => {
  const userSelectOptions = useMemo(() => users?.map((user) => ({
    label: user.userName,
    value: user.userId,
  })) || [], [users]);

  return (
    <Wrapper>
      <SelectAutocomplete
        label    = "User"
        options  = {([defaultValue] as IOption[]).concat(userSelectOptions)}
        value    = {currentUser ?? defaultValue.value }
        onChange = {onChangeUser}
      />
    </Wrapper>
  );
};
